import React, { useEffect, useState } from "react";
import { dateFormator, getEmployeeId, mapTableRows } from "../../../../utils";
import {
  Backdrop,
  Button,
  LogoLoader,
  SmartTooltip,
  StatusTags,
  TableAdv,
  FormFieldSet,
} from "../../../../components";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../hooks";
import {
  clearTimesheetData,
  getTimesheetsStart,
} from "../../../../redux/slices/timesheets/timsheetSlice";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { Link } from "react-router-dom";
import { exactUTCDate } from "../../../../utils/dateFormator";
import { TimesheetStatus } from "../../../../assets/data/enumData";
import { setEmployeeProfileUiid } from "../../../../redux/slices/employee/employeeSlice";

const MyTimesheet = () => {
  const dispatch = useDispatch();
  const { loading, error, timesheets, totalCount } = useSelector(
    (state) => state.timesheet
  );
  console.log("timesheets", timesheets);
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const [searchValue, setSearchValue] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      dispatch(
        getTimesheetsStart({
          page: newPage,
          limit: newLimit,
          filters: {
            //   employeeId:loginUserUiid,
            status: {
              type: "IN",
              value: [3, 4, 5, 6],
            },
            ...(selectedClient && {
              clientId: {
                type: "IN",
                value: [selectedClient],
              },
            }),
            ...(searchValue && {
              myTimesheetSearch: {
                type: "AG_MYTIMESHEET_SEARCH",
                value: [searchValue],
              }
            })
          },
          ...(searchValue && { useAggregate: true }),
          sort: { updatedAt: -1 },
          // sort: { uiid: 1 },
          // ret: "uiid businessName generalInfo email contact placements jobCode recordStatus",
          ref: "Employee Client Placement",
          // incl: "employeeId jobInfo.startDate jobInfo.endDate jobInfo.projectEndDate jobInfo.jobCode",
          incl: ["employmentType firstName lastName", "uiid businessName", "uiid"],
        })
      );
    }
  );

  const timesheeData = timesheets?.data || [];
  
  const timesheetDataForTable =
    timesheeData?.map((row) => ({
      employeeUiid: row?.employeeId?.uiid || 0,
      employeeId:
        getEmployeeId(row?.employeeId?.uiid, row?.employeeId?.employmentType) ||
        "-",
      employeeName: row?.employeeId
        ? `${row?.employeeId?.firstName || ""} ${row?.employeeId?.lastName || ""}`
        : "-",
      // fromDate: row?.period?.from || "-",
      // fromDate: dayjs(row?.period?.from).utc().format("MM/DD/YYYY") || "-",
      // toDate: dayjs(row.period?.to).utc().format("MM/DD/YYYY") || "-",
      fromDate: exactUTCDate(row?.period?.from) || "-",
      toDate: exactUTCDate(row.period?.to)|| "-",

      // toDate: row.period?.to || "-",
      submittedOn:
        row?.auditHistory
          ?.slice()
          ?.reverse()
          ?.find((history) => history.status === 2)?.timestamp || "-",
      totalHours: (row?.dailyEntries
        ?.reduce((acc, curr) => acc + curr.th, 0) || 0)
        .toFixed(2),
      totalBillableHours: (row?.dailyEntries
        ?.reduce((acc, curr) => acc + curr.tbh, 0) || 0)
        .toFixed(2),
      status: row.status,
      client: row.clientId?.businessName || "-",
      placementId: row?.placementId?.uiid || 0,
      timesheetId: row?.uiid || 0,
    })) || [];
  const columns = [
    {
      key: "employeeId",
      label: "Employee ID",
    },
    {
      key: "employeeName",
      label: "Employee Name",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => {
        // const name = getEmployeeName(row.employeeName).then((name) => name);
        // console.log("name in pernding", name);
        // return name || "-";
        return (
          <SmartTooltip
            description={row.employeeName}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <div
              className="flex items-center gap-1 line-clamp-1!"
              onClick={() => dispatch(setEmployeeProfileUiid(row.employeeUiid))}
            >
              <span className="text-linkblue">
                {/* //uiid is for placementID */}
                <Link
                  to="/employee/employee-profile/timesheet"
                  state={{
                    uiid: row?.placementId,
                    timesheetId: row?.timesheetId,
                    employeeId: row.employeeUiid,
                  }}
                >
                  {
                    //for testing
                    // "E" +
                    // row.employeeName +
                    // " - " +
                    // "P" +
                    // row.placementId +
                    // " - " +
                    // "T" +
                    // row.uiid
                    row.employeeName || "-"
                  }
                </Link>
              </span>
            </div>
          </SmartTooltip>
        );
      },
    },
    {
      key: "client",
      label: "Client",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => {
        return (
          <SmartTooltip
            description={row?.client}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <span className="line-clamp-1">{row?.client}</span>
          </SmartTooltip>
        );
      },
    },
    {
      key: "fromDate",
      label: "From Date",
      render: (row) => dateFormator(row.fromDate, "month-day-year"),
    },
    {
      key: "toDate",
      label: "To Date",
      render: (row) => dateFormator(row.toDate, "month-day-year"),
    },
    {
      key: "submittedOn",
      label: "Submitted On",
      render: (row) => dateFormator(row.submittedOn, "month-day-year"),
    },
    {
      key: "totalHours",
      label: "Total Hours",
    },
    {
      key: "totalBillableHours",
      label: "Total Billable Hours",
    },

    {
      key: "status",
      label: "Status",
      render: (row) => {
        return <StatusTags tag={TimesheetStatus?.find((status) => status.value === row.status)?.label || "-"} />;
      },
      sortable: false,
    },
    // {
    //   key: "actions",
    //   label: "Actions",
    //   render: (row) => (
    //     <div className="flex items-center gap-2 flex-row">
    //       <Button
    //         type="icon"
    //         icon="visibility"
    //         size="xs"
    //         variant="text"
    //         color="black"
    //       />

    //       <Button
    //         type="icon"
    //         icon="delete"
    //         size="xs"
    //         variant="text"
    //         color="black"
    //       />
    //     </div>
    //   ),
    // },
  ];
  const mappedRows = mapTableRows(timesheetDataForTable, columns);
  useEffect(() => {
    dispatch(
      getTimesheetsStart({
        page: page,
        limit: limit,
        filters: {
          //   employeeId:loginUserUiid,
          status: {
            type: "IN",
            value: [3, 4, 5, 6],
          },
            ...(selectedClient && {
              clientId: {
                type: "IN",
                value: [selectedClient],
              },
            }),
            ...(searchValue && {
              myTimesheetSearch: {
                type: "AG_MYTIMESHEET_SEARCH",
                value: [searchValue],
              }
            })
        },
        ...(searchValue && { useAggregate: true }),
        sort: { updatedAt: -1 },
        // sort: { uiid: 1 },
        // ret: "uiid businessName generalInfo email contact placements jobCode recordStatus",
        ref: "Employee Client Placement",
        // incl: "employeeId jobInfo.startDate jobInfo.endDate jobInfo.projectEndDate jobInfo.jobCode",
        incl: ["employmentType firstName lastName", "uiid businessName", "uiid"],

      })
    );
    return () => {
      dispatch(clearTimesheetData());
    };
  }, [dispatch, page, limit, searchValue, selectedClient]); // Updated dependencies

  return (
    <div className="flex flex-col overflow-hidden">
      <Backdrop isOpen={loading}>
              <LogoLoader />
            </Backdrop>
      <TableAdv
        tableId={`timesheet_mytimesheet`}
        rows={mappedRows}
        columns={columns}
        showSlNo
        fixedCol={2}
        serverPagination={true}
        // toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
        totalCount={totalCount?.data}
        page={page}
        limit={limit}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        serverOnSearch={(key, value) => {
          setPage(1);
          setSearchValue(value);
        }}
        toolbarRight={{
          
          order: ["add", "search", "filter"],
          search:true,
          filter:true,
          add: [
            {
              component: (
                <div className="cursor-pointer">
                  <FormFieldSet
                    type="allClientsList"
                    size="sm"
                    placeholder="Select Client"
                    noTitle={true}
                    value={selectedClient}
                    onChange={(option) => {
                      setPage(1);
                      setSelectedClient(option?.value || "");
                    }}
                    showClearButton={true}
                    showSearch={true}
                  />
                </div>
              ),
            },
          ],
        }}
      />
    </div>
  );
};

export default MyTimesheet;
